module.exports = __webpack_public_path__ + "media/assets/10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/10.svg
// module id = 12
// module chunks = 0